export class CustomerInsight {
  constructor({ companyId, isLike, userId, customerId, insightId }) {
    this.companyId = companyId;
    this.isLike = isLike;
    this.userId = userId;
    this.customerId = customerId;
    this.insightId = insightId;
  }
}
